import { DataSource } from '@n7-frontend/core';
import { IInnerTitleData } from '@n7-frontend/components';
export class ChartItitleDS extends DataSource {
  protected transform(data, option): IInnerTitleData {
    if (!data || !data.companies || !data.companies.length) {
      return;
    }

    const economicalData = data.companies[0].economical_data;
    const mainText = option['key'];
    let secondaryText = '';
    switch (mainText.toLowerCase()) {
      case 'ricavi':
        const lastupRev = economicalData.revenues.last_update;
        secondaryText = lastupRev ? 'Ricavi al ' + lastupRev : '';
        break;
      case 'utile':
        const lastupProfit = economicalData.profit.last_update;
        secondaryText = lastupProfit ? 'Utile al ' + lastupProfit : '';
        break;
      case 'ebitda':
        const lastupEbitda  = economicalData.ebitda.last_update;
        secondaryText = lastupEbitda ? 'EBITDA al ' + lastupEbitda : '';
        break;
    }
    return {
      title: {
        main: {
          text: mainText
        },
        secondary: {
          text: secondaryText
        }
      }
    };
  }
}

